export default {
  reset: (state, data) => Object.assign(state, data),
  myMakes: (state, data) => (state.myMakes = data),
  competitorMakes: (state, data) => (state.competitorMakes = data),

  changeMyMake: (state, data) => {
    state.myMakes = Array.isArray(data) ? data : data ? [data] : []
  },

  changeCompetitorMake: (state, data) => {
    state.competitorMakes = Array.isArray(data) ? data : data ? [data] : []
  },

  setMakes: (state, data) => (state.makes = data)
}
